export const FAILED = 'GIGRActivation/FAILED';
export const LOADING = 'GIGRActivation/LOADING';
export const SUCCESS = 'GIGRActivation/SUCCESS';
export const FILTER = 'GIGRActivation/FILTER';
